<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.ascgId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 130px;">
                        <el-option v-for="(item, index) in getAjefShopCollectionGoodsList_data" :key="index"
                            :label="item.ascgTitle" :value="item.ascgId"></el-option>
                    </el-select>
                    <!-- <el-input v-model="formDatas.ascgTitle" style="width: 120px;" size="mini" placeholder="标题"
                        clearable></el-input>
                   -->
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px"
                        @click="BoxOpen">新增商品兑换收集</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ascgrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商品兑换收集' : '新增商品兑换收集'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="标题" prop="ascgTitle">
                                <el-input v-model="form.ascgTitle" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="状态" prop="ascgStatus">
                                <el-select v-model="form.ascgStatus" placeholder="请选择" style="width: 80%;">
                                    <el-option label="保存" :value="1"></el-option>
                                    <el-option label="发布" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/YdStockMerchant.xlsx', '商品兑换收集模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjefShopCollectionGoodsList, getAjefShopList, getAjefShopCollectionGoodsRecordList, addAjefShopCollectionGoods, updateAjefShopCollectionGoods,
    uploadAjefShopStockYidong, deleteAjefShopCollectionGoodsRecord
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getAjefShopList_data: [],
            getAjefShopCollectionGoodsList_data: [],
            bulkImport: false,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "status",
                    key: "status",
                    title: "状态",
                    width: 150,
                    align: "center",
                    fixed: 'left',
                    filter: {
                        filterList: [
                            { value: 0, label: '成功', selected: false },
                            { value: 1, label: '失败', selected: false },
                            { value: 3, label: '信息不完整', selected: false }
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            console.log(filterList);
                            const labels = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.label);
                            this.searchByNameField(labels, 'status');
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        maxHeight: 120,
                    },
                },
                {
                    field: "statusMsg",
                    key: "statusMsg",
                    title: "状态备注",
                    width: 150,
                    align: "center",
                },
                {
                    field: "assyName",
                    key: "assyName",
                    title: "商户名称",
                    align: "center",
                },
            ],
            bulkData: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'ascgrId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户",
                    align: "center",
                    edit: false,
                },
                {
                    field: "ascgTitle",
                    key: "ascgTitle",
                    title: "标题",
                    align: "center",
                    edit: false,
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "填写人",
                    align: "center",
                    edit: false,
                },
                {
                    field: "asCity",
                    key: "asCity",
                    title: "城市",
                    align: "center",
                    edit: false,
                },
                {
                    field: "ascgrGoods",
                    key: "ascgrGoods",
                    title: "礼品信息",
                    align: "center",
                    width: 600,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <div style="display: flex; flex-wrap: wrap;align-items: center;"> 
                                {row.ascgrGoods ? JSON.parse(row.ascgrGoods).map((item, index) => {
                                    return (
                                        <el-card key={index} style="padding:0px;max-width:200px;">
                                            <div style="text-align: left; font-weight: bold; font-size: 10px;">
                                                兑换礼品名称 : <span style="margin-left:8px; font-size: 9px;font-weight: normal;">{item.goodsName}</span> 
                                            </div>
                                            <div style="text-align: left; font-weight: bold; font-size: 10px;margin-top: 5px;">
                                                礼品规格 : <span style="margin-left:8px; font-size: 9px;font-weight: normal;">{item.goodsPrimeCost}</span> 
                                            </div>
                                            <div style="text-align: left; font-weight: bold; font-size: 10px;margin-top: 5px;">
                                                礼品进货价格 : <span style="margin-left:8px; font-size: 9px;font-weight: normal;"> {item.goodssPecifications}</span>
                                            </div>
                                            <div style="text-align: left; font-weight: bold; font-size: 10px;margin-top: 5px;">
                                                兑换权益金 : <span style="margin-left:8px; font-size: 9px;font-weight: normal;">{item.goodsConvertQyj}</span> 
                                            </div>
                                            <div style="text-align: left; font-weight: bold; font-size: 10px;margin-top: 5px;">
                                                礼品图片 : {item.goodsImage ? item.goodsImage.map((url, index) => {
                                                    const str = <el-image ref="scrImg" id="scrimg" src={url} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                        previewSrcList={[url]}></el-image>;
                                                    return str;
                                                }) : "无"}
                                            </div>
                                        </el-card>
                                    );
                                }) : "无"}
                            </div>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },

            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getAjefShopCollectionGoodsList({ pageSize: 0 }).then(res => {
            this.getAjefShopCollectionGoodsList_data = res.data
        })
        getAjefShopList({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
    },
    mounted() { },
    methods: {
        handleDown(row) {
            this.$confirm("是否确定要暂停吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsDown({ ascgrId: row.ascgrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "暂停成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleUp(row) {
            this.$confirm("是否确定要发布吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjefShopCollectionGoodsUp({ ascgrId: row.ascgrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjefShopStockYidong(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data;
            })
        },
        bulkImportClose(done) {
            done();
            this.bulkData = [];
            this.$nextTick(() => {
                this.getList()
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-shop-collection-goods-record/exportAjefShopCollectionGoodsRecord',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'user': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '商品兑换收集记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },

        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ ascgrId: this.theRow.ascgrId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ ascgrIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShopCollectionGoodsRecord({ ascgrId: row.ascgrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopCollectionGoods(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopCollectionGoods(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ascgrId = row.ascgrId
                    console.log(jsonObj);
                    updateAjefShopCollectionGoods(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefShopCollectionGoodsRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefShopCollectionGoodsRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefShopCollectionGoodsRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>